export const FETCH_TICKET_ALERT_SETTINGS = "FETCH_TICKET_ALERT_SETTINGS"
export const FETCH_TICKET_SETTINGS = "FETCH_TICKET_SETTINGS"
